import trae from 'trae';
import tasks from '@/js/tasks';
import { envConfig } from '@/js/constants';
var TXT_SERVER_ERROR = '¡Server error on API!';
import { createToastInterface } from "vue-toastification";
var pluginOptions = {
  timeout: 4000
};

// Create the interface
var toast = createToastInterface(pluginOptions);
/**
 * validateError takes any argument.
 * @param  {Object}   responseError      Error Object from http
 * @param  {String}   additionalMessage  Message to add in alert (api info and description)
 * @param  {function} callback           Same api method to try again
 * @return {function} callback execution, reload api when access token has been expired
 */
var validateError = function validateError(responseError) {
  var additionalMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var callback = arguments.length > 2 ? arguments[2] : undefined;
  // print error
  console.log(responseError, responseError.status);
  // get token again
  tasks.lockScreen.unlock(); // unlock screen
  if (responseError.status === 400) {
    console.warn(responseError);
    console.info('Update Token 400');
    // tasks.getUserInfo(null, true)
    return responseError.data;
  } else if (responseError.status === 403) {
    console.info('Update Token 403');
    tasks.getUserInfo(null, true); // show error server
  } else if (responseError.status === 404) {
    console.log(responseError.response.data.message);
    throw responseError;
  } else if (responseError.status <= 500) {
    //alert(`${TXT_SERVER_ERROR} ${additionalMessage}`) // show error
    toast.warning(TXT_SERVER_ERROR);
    throw responseError;
  } else if (responseError.status >= 500) {
    // before >= 500
    // show error
    //alert(`${TXT_SERVER_ERROR} ${additionalMessage}`)
    toast.warning(TXT_SERVER_ERROR);
    throw responseError;
  } else if (responseError.message) {
    console.warn('TRAE: error server connection'); // trae lib error
    toast.warning(TXT_SERVER_ERROR);
    throw responseError;
  } else {
    toast.warning(TXT_SERVER_ERROR);
    console.log("Error undefined");
    throw responseError;
  }
  // launch callback
  return new Promise(function (res) {
    setTimeout(function () {
      // console.log(callback, res)
      // no need thah call again
      res(callback && callback());
      // res(responseError)
    }, envConfig.timeWaitForApi);
  });
};

/**
 * loginObj takes any argument.
 * @return {Object} to send standar
 */
var loginObj = function loginObj() {
  var email = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var tokenId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var localId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return {
    email: email || window.userInfo.email,
    tokenId: tokenId || window.userInfo.accessToken,
    localId: localId || window.userInfo.localId,
    domain: window.userInfo.domain
  };
};

// declare service app
var appApis = trae.create({
  baseUrl: envConfig['svc_apis_host']
});
var beforeMiddleware = function beforeMiddleware(config) {
  // tasks.getUserInfo()
  config.headers['Authorization'] = "Bearer " + window.userInfo.accessToken;
  return config;
};
appApis.before(beforeMiddleware);

/**
 * loginUser takes any argument.
 * @param  {String}  email    email login
 * @param  {String}  tokenId  id token returned from firebase
 * @param  {String}  localId  id assign to email UID from firebase
 * @return {Object}  user's tokens
 */
appApis.loginUser = function (email, tokenId, localId) {
  var user = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  //if (window.apiloginUser) return false

  email = email ? email.toLowerCase() : null;
  var login = loginObj(email, tokenId, localId);
  var body = {
    login: login,
    user: user
  };

  //tasks.lockScreen.lock(true)
  return appApis.post('/login_user/', body).then(function (res) {
    //tasks.lockScreen.unlock()
    //window.apiloginUser = true
    return res.data;
  }).catch(function (err) {
    //tasks.lockScreen.unlock()
    console.error(err);
    //window.apiloginUser = true
    throw err;
  });
};
export { appApis, validateError, loginObj };